import React, { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarRatings from "react-star-ratings";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Description from "./Description";
import AdditionalInformation from "./AdditionalInformation";
import Reviews from "./Reviews";
import { useDispatch, useSelector } from "react-redux";
import { allProductDetails, getProductById } from "../../Redux/ProductRedux";
import { addCartProduct, getCartProduct } from "../../Redux/CartRedux";
import Cart from "../Cart/Cart";
import toast from "react-hot-toast";
import RedirectLogin from "../ReDirect/RedirectLogin";
const BASE_URL = process.env.REACT_APP_API_URL;

function ProductDetails() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const location = useLocation();
  const [selectedQuantity, setSelectedQuantity] = useState("");
  const [activeProductTab, setActiveProductTab] = useState("Description");
  const [currentCard, setCurrentCard] = useState({ Quantity: 1 });

  const [addedCart, setAddedCart] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [quantityIndex, setQuantityIndex] = useState(null);
  const [loginOpen, setLoginOpen] = useState();
  const [productCount, setProductCount] = useState(1);

  const [quantityId, setQuantityId] = useState();
  const [flag, setFlag] = useState(false);
  const token = sessionStorage.getItem("accessToken");
  const [productDetails, setProductDetails] = useState(
    () => location.state?.product || {}
  );
  const { cartProducts } = useSelector((state) => state.cartRedux);

  useEffect(() => {
    if (userId) {
      dispatch(getCartProduct(userId)).catch((error) => {
        console.error("Error fetching cart:", error);
      });
    }
    if (productDetails) {
      const { __v, ...rest } = productDetails;
      setCurrentCard({
        ...rest,
        Quantity: 1,
        user_id: userId,
        phoneNo: phoneNo,
        userName: userName,
      });
    } else if (id) {
      dispatch(allProductDetails(id));
    }
  }, [productDetails, id]);

  useEffect(() => {
    dispatch(getProductById(id))
      .then((results) => {
        if (results) {
          setProductDetails(results);
          setFlag(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [flag]);

  useEffect(() => {
    try {
      if (cartProducts && quantityId) {
        setAddedCart(false);
        cartProducts.cart.items.forEach((item) => {
          const matchingPriceAndQuantity = item.priceAndQuantity.find(
            (pq) => pq._id === quantityId
          );

          if (matchingPriceAndQuantity) {
            setAddedCart(true);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, [cartProducts, quantityId, drawerOpen]);

  const userId =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).userId;

  const userRole =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).role;

  const userName =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).userName;

  const phoneNo =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).phoneNo;

  useEffect(() => {
    if (productDetails) {
      const { __v, ...rest } = productDetails;
      setCurrentCard({
        ...rest,
        Quantity: 1,
        user_id: userId,
        phoneNo: phoneNo,
        userName: userName,
      });
    } else if (id) {
      dispatch(getProductById(id));
    }
  }, [productDetails, id]);

  const images =
    currentCard.images && currentCard.images.length > 0
      ? currentCard.images.map((img) => ({
          original: `${BASE_URL}/assets/images/products/${img.image}`,
          thumbnail: `${BASE_URL}/assets/images/products/${img.image}`,
        }))
      : [];

  const increaseQuantity = () => {
    setCurrentCard((prevCard) => ({
      ...prevCard,
      Quantity:
        prevCard.Quantity < prevCard.priceAndQuantity.totalCount
          ? prevCard.Quantity + 1
          : prevCard.Quantity,
    }));
  };

  const decreaseQuantity = () => {
    setCurrentCard((prevCard) => ({
      ...prevCard,
      Quantity: prevCard.Quantity > 1 ? prevCard.Quantity - 1 : 1,
    }));
  };

  const handleSelect = (e) => {
    if (e.target.value !== "") {
      const quantityId =
        productDetails.priceAndQuantity[e.target.selectedIndex - 1]._id;
      setQuantityId(quantityId);
      const availableQuantities =
        productDetails.priceAndQuantity[e.target.selectedIndex - 1].totalCount;
      setProductCount(availableQuantities);
      const selectedValue = e.target.value;
      const selectedIdx = e.target.selectedIndex - 1;
      setQuantityIndex(selectedIdx >= 0 ? selectedIdx : null);
      setSelectedQuantity(selectedValue);

      setCurrentCard((prevCard) => {
        if (selectedValue === "") {
          return { ...prevCard, Quantity: 1 };
        }

        if (selectedIdx >= 0 && prevCard.priceAndQuantity) {
          const selectedPriceQuantity =
            productDetails.priceAndQuantity[selectedIdx];
          return {
            ...prevCard,
            priceAndQuantity: selectedPriceQuantity,
          };
        }
        return prevCard;
      });
    }
  };

  const handleTab = (tab) => {
    setActiveProductTab(tab);
  };

  const availableQuantities = productDetails.priceAndQuantity
    ? productDetails.priceAndQuantity.map((item) => item.quantity)
    : [];

  const handleDrawerClose = () => {
    dispatch(getCartProduct(userId))
      .then((result) => {
        if (result) {
          setDrawerOpen(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleCart = () => {
    if (selectedQuantity === "") {
      toast.error("Please select quantity");
    } else if (!token) {
      setLoginOpen(true);
    } else {
      dispatch(addCartProduct(currentCard)).then((result) => {
        if (result.status === "success") {
          setAddedCart(true);
          setDrawerOpen(true);
        }
      });
    }
  };

  const handleLogin = () => {
    setLoginOpen(false);
  };

  return (
    <div className='container-fluid'>
      <div className="row p-5">
        <div className="col-md-4 col-sm-12">
          <ImageGallery
            items={images}
            showBullets={false}
            showPlayButton={false}
            showThumbnails={true}
            showNav={false}
            showFullscreenButton={true}
            containerClassName="custom-gallery"
          />
        </div>

        <div className="col-md-8 col-sm-12">
          <h4>{currentCard.productName}</h4>

          <h6>
            From ₹
            {productDetails.priceAndQuantity &&
              productDetails.priceAndQuantity.length > 0
              ? Math.min(
                ...productDetails.priceAndQuantity.map((item) => item.price)
              )
              : "-"}
            .00/-
          </h6>

          <StarRatings
            rating={Number(productDetails.rating) || 0}
            starRatedColor="gold"
            numberOfStars={5}
            starDimension="17px"
            starSpacing="2px"
            name="rating"
          />

          <div className="row mt-3">
            <p style={{ textAlign: "justify" }}>
              {currentCard.description?.shortDescription}
            </p>
          </div>

          {/* Category */}
          <div className="label-container mt-4">
            <div className="label-text">Category</div>
            <div className="label-colon">:</div>
            <div className="value-text">
              {currentCard.underCategory && currentCard.underCategory.length > 0
                ? currentCard.underCategory
                  .map((categoryObj) => categoryObj.category)
                  .join(", ")
                : "No categories available"}
            </div>
          </div>
          {/* Quantity */}
          <div className="label-container row align-items-center">
            <div className="label-text col-auto">Quantity</div>
            <div className="label-colon col-auto">:</div>
            <div className="value-text  d-inline-flex align-items-center">
              <div className="row g-4 align-items-center">
                <div className="col-auto">
                  <select
                    className="form-select p-1 mx-3"
                    value={selectedQuantity}
                    onChange={handleSelect}
                    disabled={productDetails.status?.toLowerCase() === "out of stock"}
                  >
                    <option value="">Select</option>
                    {availableQuantities.map((quantity, index) => (
                      <option
                        key={index}
                        value={quantity}
                        disabled={quantity === 0 || quantity === ""}
                      >
                        {quantity || 0}
                      </option>
                    ))}
                  </select>
                </div>
                {quantityIndex !== undefined && quantityIndex !== null && (
                  <div className="col-auto">
                    <span>
                      Price: ₹{" "}
                      {currentCard.priceAndQuantity &&
                        currentCard.priceAndQuantity.price
                        ? Number(currentCard.priceAndQuantity.price).toFixed(2)
                        : "-"}
                      /-
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Add Count */}
          {productCount !== 0 && userRole !== "seller" && userRole !== "admin" && (
            <div className="label-container">
              <div className="label-text">Add Count</div>
              <div className="label-colon">:</div>
              <div className="value-text d-flex align-items-center">
                <IconButton
                  className="text-primary"
                  onClick={decreaseQuantity}
                  variant="text"
                  style={{
                    cursor: currentCard.Quantity === 1 && "not-allowed",
                  }}
                >
                  -
                </IconButton>
                <span style={{ margin: "0 20px" }}>{currentCard.Quantity}</span>
                <IconButton
                  className="text-primary"
                  onClick={increaseQuantity}
                  variant="text"
                  style={{
                    cursor:
                      currentCard.Quantity === productCount && "not-allowed",
                  }}
                >
                  +
                </IconButton>
              </div>
            </div>
          )}

          {/* Total Price */}
          {quantityIndex !== undefined && quantityIndex !== null && (
            <div className="label-container">
              <div className="label-text">Total Price</div>
              <div className="label-colon">:</div>
              <div className="value-text">
                <span className="border rounded p-2">
                  ₹{" "}
                  {currentCard.priceAndQuantity &&
                    !isNaN(currentCard.Quantity)
                    ? (currentCard.Quantity *
                      currentCard.priceAndQuantity.price
                    ).toFixed(2)
                    : "-"}
                  /-
                </span>
              </div>
            </div>
          )}

          {/* Add to Cart */}
          {userRole !== "seller" && userRole !== "admin" && (
            <div className="row mt-4">
              <div className="col-12 col-md-4">
                <Button
                  variant="contained"
                  className="btn"
                  style={{
                    background: addedCart
                      ? "#4caf50"
                      : productDetails.status?.toLowerCase() === "out of stock"
                        ? "#ccc"
                        : "var(--primary-color)",
                    color:
                      addedCart ||
                        productDetails.status?.toLowerCase() === "out of stock"
                        ? "#666"
                        : "#fff",
                  }}
                  startIcon={
                    addedCart ? <CheckCircleIcon /> : <AddShoppingCartIcon />
                  }
                  fullWidth
                  onClick={handleCart}
                  disabled={
                    addedCart ||
                    productDetails.status?.toLowerCase() === "out of stock" ||
                    availableQuantities.every((qty) => !qty || qty === 0)
                  }
                >
                  {addedCart ? "Added to Cart" : "Add To Cart"}
                </Button>
              </div>
            </div>
          )}

          {/* Out of Stock message */}
          {productDetails.status &&
            productDetails.status.toLowerCase() === "out of stock" && (
              <div className="row mt-2">
                <div className="col-auto text-danger fw-bold">Out Of Stock</div>
              </div>
            )}
        </div>
      </div>



      <div className='row'>
        <div className="col-12">
          <ul className="nav nav-pills">
            <li className="nav-item col-6 text-center">
              <Button
                sx={{
                  backgroundColor:
                    activeProductTab === "Description"
                      ? "success.main"
                      : "transparent",
                  color:
                    activeProductTab === "Description" ? "#fff" : "#136c19",
                  // borderColor:
                  //   activeProductTab === 'Delivered' ? 'transparent' : 'divider',
                  "&:hover": {
                    backgroundColor:
                      activeProductTab === "Description"
                        ? "success.dark"
                        : "action.hover",
                  },
                }}
                onClick={() => handleTab("Description")}
              >
                Description
              </Button>
            </li>
            <li className="nav-item col-6 text-center">
              <Button
                sx={{
                  backgroundColor:
                    activeProductTab === "Reviews"
                      ? "success.main"
                      : "transparent",
                  color: activeProductTab === "Reviews" ? "#fff" : "#136c19",
                  "&:hover": {
                    backgroundColor:
                      activeProductTab === "Reviews"
                        ? "success.dark"
                        : "action.hover",
                  },
                }}
                onClick={() => handleTab("Reviews")}
              >
                Reviews
              </Button>
            </li>
          </ul>
        </div>
      </div>
      <div className="row my-3 border border-success-subtle">
        <div className="col-12">
          {activeProductTab === "Description" && (
            <Description
              description={productDetails}
            />
          )}
          {/* {activeProductTab === "Additional Information" && (
            <AdditionalInformation productDetails ={productDetails.priceAndQuantity}/>
          )} */}
          {activeProductTab === "Reviews" && (
            <Reviews productDetails={productDetails} setFlag={setFlag} />
          )}
        </div>
      </div>
      {token ? (
        <Cart drawerOpen={drawerOpen} handleDrawerClose={handleDrawerClose} />
      ) : (
        <RedirectLogin open={loginOpen} handleClose={handleLogin} />
      )}
    </div>
  );
}

export default ProductDetails;
